module.exports = __webpack_public_path__ + "img/1440.20cd57a5.jpg";